module.exports = __webpack_public_path__ + "assets/nodata.0ad6ab61.svg";